/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedUserList } from '../models/PaginatedUserList';
import type { PatchedUserDetail } from '../models/PatchedUserDetail';
import type { UserActivate } from '../models/UserActivate';
import type { UserDetail } from '../models/UserDetail';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * Copy of django-rest-framework's `ListAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns PaginatedUserList
     * @throws ApiError
     */
    public static userList({
        active,
        groupNamesIn,
        healthcareEntityId,
        limit,
        offset,
        ordering,
        roleIn,
        search,
    }: {
        active?: boolean,
        groupNamesIn?: Array<string>,
        healthcareEntityId?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        /**
         * * `ADMIN` - Administrator
         * * `RECRUIT` - Recruiter
         * * `SCHED` - Scheduler
         * * `COMMON` - Common
         */
        roleIn?: Array<'ADMIN' | 'COMMON' | 'RECRUIT' | 'SCHED'>,
        search?: string,
    }): CancelablePromise<PaginatedUserList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/',
            query: {
                'active': active,
                'group_names__in': groupNamesIn,
                'healthcare_entity_id': healthcareEntityId,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'role__in': roleIn,
                'search': search,
            },
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns UserDetail
     * @throws ApiError
     */
    public static userRetrieve({
        id,
    }: {
        id: string,
    }): CancelablePromise<UserDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns UserDetail
     * @throws ApiError
     */
    public static userUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: UserDetail,
    }): CancelablePromise<UserDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns UserDetail
     * @throws ApiError
     */
    public static userPartialUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PatchedUserDetail,
    }): CancelablePromise<UserDetail> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/user/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Copy of django-rest-framework's `RetrieveAPIView`
     * but with changes to call the method `get_optimized_queryset`
     * from the associated `VirtualModelSerializer`.
     * This ensures the queryset used by the serializer will
     * contain all annotations, joins, and prefetches needed.
     * @returns void
     * @throws ApiError
     */
    public static userDestroy({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns UserDetail
     * @throws ApiError
     */
    public static userReactivateUpdate({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: UserActivate,
    }): CancelablePromise<UserDetail> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/{id}/reactivate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
